export default "__VITE_ASSET__DFa1gC6O__"